import { isValidEmail } from './footerModels';

interface ContactNameValidationInput {
  name: string;
}

interface ContactEmailValidationInput {
  email: string;
}

interface ContactMessageValidationInput {
  message: string;
}

export function getNameValidationError({
  name,
}: ContactNameValidationInput): string | null {
  return name.trim().length === 0 ? 'Name is required' : null;
}

export function getEmailValidationError({
  email,
}: ContactEmailValidationInput): string | null {
  if (email.trim().length === 0) {
    return 'Email is required';
  }
  return isValidEmail({ email: email.trim() }) ? null : 'Invalid email format';
}

export function getMessageValidationError({
  message,
}: ContactMessageValidationInput): string | null {
  return message.trim().length === 0 ? 'Message is required' : null;
}
